//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import BackendServices from "@/services/backend-services.js";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";

export default {
  name: "StoresTab",
  props: ["value", "refData"],
  components: {},
  mounted: function() {
    // this.selectedRetailer = this.value.hierarchy[0].id;
    // this.selectedInsignia = this.value.hierarchy[1].id;

    BackendServices.getStoreHierarchyLevels();

    this.loadHierarchyLists();
    this.validateData();
  },
  computed: {
    selectedRetailerName: function() {
      let retailer = this.retailerList.filter(
        item => item.id === this.selectedRetailer
      );

      if (retailer.length) {
        return retailer.pop().name;
      } else {
        return null;
      }
    },
    selectedInsigniaName: function() {
      let insignia = this.insigniaList.filter(
        item => item.id === this.selectedInsignia
      );

      if (insignia.length) {
        return insignia.pop().name;
      } else {
        return null;
      }
    },
    selectedChainName: function() {
      let chain = this.chainList.filter(
        item => item.id === this.value.least_store_hierarchy_level_element_id
      );

      if (chain.length) {
        return chain.pop().name;
      } else {
        return null;
      }
    }
  },
  data: function() {
    return {
      moment,
      validForm: false,
      selectedRetailer: null,
      selectedInsignia: null,
      aggregatorList: [{id: null, name: "Sem Agregador"}].concat(this.refData),
      retailerList: [],
      insigniaList: [],
      chainList: [],
      storeList: []
    };
  },
  methods: {
    required,
    noValidation,
    validateData: function() {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    loadHierarchyLists() {
      BackendServices.getRetailers().then(response => {
        this.retailerList = response.data;
      });
      BackendServices.getInsigniaByRetailer(this.selectedRetailer).then(
        response => {
          this.insigniaList = response.data;
        }
      );
      BackendServices.getChainsByInsignia(this.selectedInsignia).then(
        response => {
          this.chainList = response.data;
        }
      );
    },
    updateData() {
      this.$emit("value", this.value);
    }
  }
};
